import { makeStyles, Grid, Typography, Button } from "@material-ui/core";
import { useSelector } from "react-redux";

import { data } from "./sample";
import { nFormatter } from "../../../../services/utils";
import { Icon } from "../../../../components/base/Icon";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";
import { RadialBarChart } from "../../../../components/charts/RadialBarChart";
import AllowancesTrading from "../../../../assets/images/icons/allowances-trading.svg";
import VoluntaryCredits from "../../../../assets/images/icons/voluntary-credits.svg";
import OffsetCredits from "../../../../assets/images/icons/offset-credits.svg";
import { COLORS } from "../../../../theme/colors";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(4)}px`,
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
  },
  primaryRow: {
    maxWidth: "410px",
  },
  secondaryRow: {
    maxWidth: "200px",
    "&:not(:last-child)": {
      marginBottom: 10,
    },
  },
  mainTypography: {
    fontSize: 36,
    marginRight: 30,
  },
  typographyColorA: {
    color: "#349E88",
  },
  typographyColorB: {
    color: "#A2F8A9",
  },
  typographyColorC: {
    color: "#4EE3C5",
  },
  price: {
    fontSize: 24,
    fontWeight: 700,
    textTransform: "uppercase",
  },
  rowTitle: {
    fontSize: 18,
    lineHeight: "24px",
  },
  rowDescription: {
    fontSize: 14,
    lineHeight: "36px",
  },
  info: {
    flex: 1,
    maxWidth: 442,
  },
  bottom: {
    paddingBottom: 20,
    marginBottom: 20,
    borderBottom: "1px solid #DFE0EB",
  },
  radialBarChart: {
    margin: "0 auto",
  },
  optimizeBtn: {
    display: "block",
    margin: "30px auto 20px",
    color: COLORS.white,
    backgroundColor: COLORS.purple,
    borderRadius: 21,
    "&:hover": {
      backgroundColor: COLORS.hovered_purple,
      color: COLORS.white,
    },
  },
  increaseBtn: {
    display: "block",
    margin: "0 auto",
    color: COLORS.purple,
    backgroundColor: COLORS.white,
    borderRadius: 21,
    "&:hover": {
      backgroundColor: COLORS.white,
      color: COLORS.hovered_purple,
    },
  },
}));

export const Strategies = () => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  const getTypographyColor = (i) => {
    switch (i) {
      case 0:
        return classes.typographyColorA;
      case 1:
        return classes.typographyColorB;
      case 2:
        return classes.typographyColorC;
      default:
        return classes.typographyColorA;
    }
  };

  const getIcon = (i) => {
    switch (i) {
      case 0:
        return AllowancesTrading;
      case 1:
        return VoluntaryCredits;
      case 2:
        return OffsetCredits;
      default:
        return AllowancesTrading;
    }
  };

  return (
    <ShaDowBox>
      <div className={classes.box}>
        <Grid container spacing={0}>
          <Grid item sm={6}>
            {data.map((item, i) => (
              <Grid container key={i}>
                <Grid
                  item
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: 40,
                  }}
                >
                  <Typography className={`${classes.mainTypography} ${getTypographyColor(i)}`}>
                    {item.type}
                  </Typography>
                  <Icon src={getIcon(i)} />
                </Grid>
                <Grid item className={`${classes.info} ${i === 2 ? null : classes.bottom}`}>
                  <div className={`${classes.row} ${classes.primaryRow}`}>
                    <Typography className={classes.rowTitle}>{item.name}</Typography>
                    <Typography className={classes.price}>
                      <span style={{ fontSize: 14 }}>{currencySymbol}</span>
                      {nFormatter(item.total)}
                    </Typography>
                  </div>
                  <div className={`${classes.row} ${classes.secondaryRow}`}>
                    <Typography className={classes.rowDescription}>Expected quantity</Typography>
                    <Typography className={classes.rowDescription}>{item.quality} tCO2</Typography>
                  </div>
                  <div className={`${classes.row} ${classes.secondaryRow}`}>
                    <Typography className={classes.rowDescription}>Expected price</Typography>
                    <Typography className={classes.rowDescription}>${item.price} tCO2</Typography>
                  </div>
                </Grid>
              </Grid>
            ))}
          </Grid>
          <Grid item sm={6}>
            <Typography variant="h4" style={{ marginBottom: 30, textAlign: "center" }}>
              Total expected Revenue by strategies
            </Typography>
            <RadialBarChart />
            <Button variant="contained" className={classes.optimizeBtn}>
              Optimize your strategy
            </Button>
            <Button className={classes.increaseBtn}>increase expected revenues</Button>
          </Grid>
        </Grid>
      </div>
    </ShaDowBox>
  );
};
